<!-- 日活 -->

<template>
  <div class="dashboard-container tab-margin">
    <!-- 搜索 S -->
    <div class="top-search tab-padding">
      <div class="search">
        <div class="arrow" @click="changeShow()">
          <i class="el-icon-arrow-down" v-if="optionsHidden"></i>
          <i class="el-icon-arrow-up" v-else></i>
        </div>
        <div class="content" :class="{ autoHeight: optionsHidden }">
          <div class="flex-1">
            <el-form label-position="top" inline label-width="100px">
              <el-form-item label="用户国家" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.dev_country"
                  placeholder="用户国家"
                  :filter-method="countryFilter"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="用户城市" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.dev_city"
                  placeholder="用户城市"
                  :filter-method="cityFilter"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="用户网络" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.network"
                  placeholder="用户网络"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in networkOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户ISP" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.dev_isp"
                  placeholder="用户ISP"
                  :filter-method="ispFilter"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in ispOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户操作系统" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.os"
                  placeholder="用户操作系统"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in osOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作系统版本" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.os_ver"
                  placeholder="操作系统版本"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in opVerOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="app版本" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.pkg_ver"
                  placeholder="app系统版本"
                  :filter-method="appVerFilter"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in appVerOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="flex-1">
            <el-form label-position="top" inline label-width="100px">
              <el-form-item label="服务器城市" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.server_city"
                  placeholder="服务器城市"
                  :filter-method="scityFilter"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in serCityOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务器型号" class="form-label">
                <el-select
                  filterable
                  style="width: 220px"
                  v-model="temp.server_type"
                  placeholder="服务器型号"
                  :disabled="isDisabled"
                  multiple
                >
                  <el-option
                    v-for="item in serTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务器负载范围" class="form-label">
                <el-input
                  style="width: 220px"
                  v-model="temp.server_load"
                  placeholder="开始-结束 例: 1-99"
                  :disabled="isDisabled"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="flex-1">
          <el-form label-position="top" inline label-width="120px">
            <el-form-item label="当前App" class="form-label">
              <el-select
                filterable
                style="width: 220px"
                v-model="cur_app"
                placeholder="当前App"
                @change="changeApp"
              >
                <el-option
                  v-for="item in appOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.pkg"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="聚合维度" class="form-label">
              <el-select
                filterable
                style="width: 220px"
                v-model="temp.groupby"
                placeholder="聚合维度"
              >
                <el-option
                  v-for="item in optionsGroup"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期范围" class="form-label">
              <el-date-picker
                style="width: 320px"
                v-model="timeWrap"
                type="datetimerange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <div class="btns" style="margin-top: 40px; display: inline-block">
              <el-button
                type="primary"
                icon="el-icon-refresh-right"
                class="search-btn"
                @click="reset"
                :loading="btn_loading"
                >重置</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="search"
                :loading="btn_loading"
                >搜索</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-plus"
                class="search-btn"
                @click="add"
                :loading="btn_loading"
                >新增对比数据</el-button
              >
            </div>
          </el-form>

          <span class="tip">
            <i class="el-icon-warning-outline"></i
            >重置：清空当前保留数据，新增对比数据：保留当前数据，然后再获取一组新的比较数据
          </span>
        </div>
      </div>
    </div>

    <div class="tab-container" style="margin-top: 20px">
      <div class="chart-wrap">
        <div class="c-top">
          <h4>分位数</h4>
        </div>
        <line-chart
          v-if="lineShow"
          :chartData="chartdata"
          :options="options"
        ></line-chart>
      </div>
      <div class="chart-wrap">
        <div class="c-top">
          <h4>占比 x 100</h4>
        </div>
        <bar-chart
          v-if="columnarShow"
          :chartData="columnarData"
          :options="options"
        ></bar-chart>

        <span class="tip">
          <i class="el-icon-warning-outline"></i>
          <span>0m-1m 基本是连上后没有网， </span>
          <span>1m-3m 连上后没有网，或者网络极差，</span>
          <span>3m-5m 连上后有网，但是卡的很，</span>
          <span>5m-10m 连上后有网，比较卡，但是可以忍受，</span>
          <span>10m-30m 连上后有网，网速不理想，但是可以忍受，</span>
          <span>30m-1h 连上后有网，网速还可以接受，</span>
          <span>1h ~ 5h 基本不影响使用，</span>
          <span> 5h ~ 基本不影响使用</span>
        </span>
      </div>
      <div class="chart-wrap">
        <div class="c-top">
          <h4>数值占比</h4>
        </div>
        <pie-chart
          v-if="pieShow"
          :chartData="chartdataPie"
          :options="optionsPie"
        ></pie-chart>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import { appList } from "@/api/app.js";
import {
  getTimeSpeedChart,
  getTimeOthersChart,
  getTimeChartOptions,
} from "@/api/chart.js";
import LineChart from "./lineChart.vue";
import BarChart from "./barChart.vue";
import PieChart from "./pieChart.vue";

export default {
  name: "Dashboard",
  components: {
    LineChart,
    BarChart,
    PieChart,
  },
  computed: {
    ...mapGetters(["pickerOptions"]),
  },
  data() {
    return {
      optionsHidden: false,
      isDisabled: false, //切换app时，重新请求select参数，不可点击
      btn_loading: false,

      lineShow: false,
      columnarShow: false,
      pieShow: false,

      loading: false,
      timeWrap: [],
      appOption: [],
      cur_app: "",
      temp: {
        pkg: "",
        dev_country: [],
        dev_city: [],
        network: "",
        dev_isp: [],
        os: [],
        os_ver: [],
        pkg_ver: [],
        server_city: [],
        server_type: [],
        server_load: "",
        groupby: [],
        s_dt: "",
        e_dt: "",
      },

      optionsGroup: [
        {
          value: "network",
          label: "用户网络",
        },
        {
          value: "dev_city",
          label: "用户城市",
        },
        {
          value: "dev_isp",
          label: "用户ISP",
        },
        {
          value: "server_city",
          label: "服务器城市",
        },
        {
          value: "server_type",
          label: "服务器型号",
        },
      ],

      countryOptions: [],
      cityOptions: [],
      ispOptions: [],
      networkOptions: [],
      osOptions: [],
      opVerOptions: [],
      appVerOptions: [],
      serCityOptions: [],
      serTypeOptions: [],

      chartdata: {}, //折线图
      columnarData: {}, //柱状图
      chartdataPie: {}, //饼状图

      optionsPie: {
        responsive: true,
        maintainAspectRatio: false,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
      colors: [
        "rgba( 255, 162, 0, 1)",
        "rgba( 213, 232, 100, 1)",
        "rgba( 0, 255, 115, 1)",
        "rgba( 12, 110, 232, 1)",
        "rgba( 164, 3, 255, 1)",
        "rgba( 255, 72, 0, 1)",
        "rgba( 232, 221, 100, 1)",
        "rgba( 0, 255, 115, 1)",
        "rgba( 12, 36, 232, 1)",
        "rgba( 255, 0, 97, 1)",
        "rgba( 140, 0, 255, 1)",
        "rgba( 100, 165, 232, 1)",
        "rgba( 0, 255, 115, 1)",
        "rgba( 188, 232, 12, 1)",
        "rgba( 255, 176, 23, 1)",
      ],
      bgcColors: [
        "rgba( 255, 162, 0, 0.2)",
        "rgba( 213, 232, 100, 0.2)",
        "rgba( 0, 255, 115, 0.2)",
        "rgba( 12, 110, 232, 0.2)",
        "rgba( 164, 3, 255, 0.2)",
        "rgba( 255, 72, 0, 0.2)",
        "rgba( 232, 221, 100, 0.2)",
        "rgba( 0, 255, 115, 0.2)",
        "rgba( 12, 36, 232, 0.2)",
        "rgba( 255, 0, 97, 0.2)",
        "rgba( 140, 0, 255, 0.2)",
        "rgba( 100, 165, 232, 0.2)",
        "rgba( 0, 255, 115, 0.2)",
        "rgba( 188, 232, 12, 0.2)",
        "rgba( 255, 176, 23, 0.2)",
      ],

      lineData: [],
      ts_bar_data: [], //暂存数据
      ts_line_data: [],
    };
  },

  created() {
    // 筛选项收起展开
    this.optionsHidden = Cookies.get("showStatus") === "true" ? true : false;
    // 初始化 app列表
    let appOption = JSON.parse(localStorage.getItem("topAppList"));
    
    if (appOption) {
      this.appOption = appOption;
    } else {
      // 从接口获取
      let _topAppList = [];
      appList({ project_id: localStorage.getItem("project_id") }).then(
        (resp) => {
          resp.forEach((item) => {
            _topAppList.push({
              name: item.name,
              id: item.id,
              pkg: item.pkg,
            });
          });
          localStorage.setItem("topAppList", JSON.stringify(_topAppList));
          this.appOption = _topAppList;
        }
      );
    }

    // 初始化 当前选中app，没有就列表第一个
    let chart_pkg = sessionStorage.getItem("chart_pkg");
    if (chart_pkg) {
      this.cur_app = chart_pkg;
    } else {
      this.cur_app = this.appOption[0].pkg;
    }
  },

  mounted() {
    this.initOptionsQuery();
  },

  methods: {
    changeApp(val) {
      sessionStorage.setItem("chart_pkg", val);
      this.getOptions();
    },

    // 初始化选项
    initOptionsQuery() {
      let chartAllOptions = JSON.parse(
        sessionStorage.getItem("chart_time_options")
      );
      if (chartAllOptions) {
        let {
          dev_city,
          dev_country,
          dev_isp,
          network,
          os,
          os_ver,
          pkg_ver,
          server_city,
          server_type,
        } = chartAllOptions;

        this.dev_country = dev_country;
        this.dev_city = dev_city;
        this.dev_isp = dev_isp;
        this.pkg_ver = pkg_ver;
        this.server_city = server_city;

        this.countryFilter();
        this.cityFilter();
        this.ispFilter();
        this.appVerFilter();
        this.scityFilter();

        this.networkOptions = network;
        this.osOptions = os;
        this.opVerOptions = os_ver;
        this.serTypeOptions = server_type;
      } else {
        this.getOptions();
      }
    },

    getOptions() {
      let params = {
        // pkg: "com.free.vpn.proxy.hotspot.snapvpn",
        pkg: this.cur_app,
      };
      this.isDisabled = true;
      getTimeChartOptions(params)
        .then((res) => {
          console.log(res);
          sessionStorage.setItem(
            "chart_time_options",
            JSON.stringify(res.data)
          );
          let {
            dev_city,
            dev_country,
            dev_isp,
            network,
            os,
            os_ver,
            pkg_ver,
            server_city,
            server_type,
          } = res.data;

          this.dev_country = dev_country;
          this.dev_city = dev_city;
          this.dev_isp = dev_isp;
          this.pkg_ver = pkg_ver;
          this.server_city = server_city;

          this.countryFilter();
          this.cityFilter();
          this.ispFilter();
          this.appVerFilter();
          this.scityFilter();

          this.networkOptions = network;
          this.osOptions = os;
          this.opVerOptions = os_ver;
          this.serTypeOptions = server_type;

          this.isDisabled = false;
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },

    changeShow() {
      this.optionsHidden = !this.optionsHidden;
      Cookies.set("showStatus", this.optionsHidden);
    },

    search() {
      this.getLineChartData();
      this.getBarChartData();
      this.getPieChartData();
    },

    // 获取折线图接口
    getLineChartData() {
      let params = Object.assign({}, this.temp);
      params.pkg = this.cur_app;
      params.s_dt = this.timeWrap[0];
      params.e_dt = this.timeWrap[1];
      params.server_load = this.temp.server_load ? this.temp.server_load.replace(/\s*/g, "").split("-") : [];

      this.lineShow = false;
      this.btn_loading = true;

      getTimeSpeedChart(params).then((res) => {
        let { data } = res;
        let _copy = JSON.parse(JSON.stringify(data));
        let _t_l_d = JSON.parse(sessionStorage.getItem("time_line_data")) || [];

        // 渲染图表
        this.getLineData(_copy);
        this.lineShow = true;
        this.btn_loading = false;
        this.time_line_data = _t_l_d.concat(data);
      });
    },

    // 获取柱状图接口
    getBarChartData() {
      let params = Object.assign({}, this.temp);
      params.is_rate = 1;
      params.pkg = this.cur_app;
      params.s_dt = this.timeWrap[0];
      params.e_dt = this.timeWrap[1];
      params.server_load = this.temp.server_load ? this.temp.server_load.replace(/\s*/g, "").split("-") : [];

      this.columnarShow = false;

      getTimeOthersChart(params).then((res) => {
        let { data } = res;
        let _copy = JSON.parse(JSON.stringify(data));
        let _t_b_d = JSON.parse(sessionStorage.getItem("time_bar_data")) || [];

        // 渲染图表
        this.getColuData(_copy);
        this.columnarShow = true;
        this.time_bar_data = _t_b_d.concat(data);
      });
    },

    // 获取饼状图接口
    getPieChartData() {
      let params = Object.assign({}, this.temp);
      params.is_rate = 0;
      params.pkg = this.cur_app;
      params.s_dt = this.timeWrap[0];
      params.e_dt = this.timeWrap[1];
      params.server_load = this.temp.server_load ? this.temp.server_load.replace(/\s*/g, "").split("-") : [];

      this.pieShow = false;

      getTimeOthersChart(params).then((res) => {
        let { data } = res;
        let _copy = JSON.parse(JSON.stringify(data));
        let _t_p_d = JSON.parse(sessionStorage.getItem("time_pie_data")) || [];

        // 渲染图表
        this.getPieData(_copy);
        this.pieShow = true;
        this.time_pie_data = _t_p_d.concat(data);
      });
    },

    reset() {
      // 移除当前数据
      sessionStorage.removeItem("time_line_data");
      sessionStorage.removeItem("time_bar_data");
      sessionStorage.removeItem("time_pie_data");

      this.$message({
        message: "重置成功！",
        type: "success",
      });
      this.search();
    },

    add() {
      console.log(this.ts_bar_data, this.ts_line_data);
      // 本地存当前数据
      sessionStorage.setItem(
        "time_line_data",
        JSON.stringify(this.time_line_data)
      );
      sessionStorage.setItem(
        "time_bar_data",
        JSON.stringify(this.time_bar_data)
      );
      sessionStorage.setItem(
        "time_pie_data",
        JSON.stringify(this.time_pie_data)
      );

      this.$message({
        message: "当前数据暂存成功，可再获取新数据",
        type: "success",
      });
    },

    getLineData(_data) {
      // 初始化坐标数据格式
      this.chartdata = {
        labels: ["10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%"],
        datasets: [],
      };

      // 本地缓存有数据，拼接
      let _ts = JSON.parse(sessionStorage.getItem("time_line_data"));
      if (_ts) {
        this.chartdata.datasets = _ts.concat(_data);
      } else {
        this.chartdata.datasets = _data;
      }

      // 折线图配置
      this.chartdata.datasets.map((item, index) => {
        item.backgroundColor = this.bgcColors[index];
        item.borderColor = this.colors[index];
        item.fill = false;
        item.borderWidth = 1;
      });

      this.lineShow = true;
    },

    getColuData(_data) {
      // 初始化坐标数据格式
      this.columnarData = {
        labels: [
          "0m ~ 1m",
          "1m ~ 3m",
          "3m ~ 5m",
          "5m ~ 10m",
          "10m ~ 30m",
          "30m ~ 1h",
          "1h ~ 5h",
          "> 5h",
        ],
        datasets: [],
      };

      // 本地缓存有数据，拼接
      let _ts = JSON.parse(sessionStorage.getItem("time_bar_data"));
      if (_ts) {
        this.columnarData.datasets = _ts.concat(_data);
      } else {
        this.columnarData.datasets = _data;
      }

      // 柱状图配置
      this.columnarData.datasets.map((item, index) => {
        item.backgroundColor = this.bgcColors[index];
        item.borderColor = this.colors[index];
        item.fill = false;
        item.borderWidth = 1;
      });

      this.columnarShow = true;
    },

    getPieData(_data) {
      // 初始化坐标数据格式
      this.chartdataPie = {
        labels: [
          "0m ~ 1m",
          "1m ~ 3m",
          "3m ~ 5m",
          "5m ~ 10m",
          "10m ~ 30m",
          "30m ~ 1h",
          "1h ~ 5h",
          "> 5h",
        ],
        datasets: [],
      };

      // 本地缓存有数据，拼接
      let _tp = JSON.parse(sessionStorage.getItem("time_pie_data"));
      if (_tp) {
        this.chartdataPie.datasets = _tp.concat(_data);
      } else {
        this.chartdataPie.datasets = _data;
      }

      // 饼状图配置
      this.chartdataPie.datasets.map((item) => {
        item.backgroundColor = [
          "#E8647C",
          "#FF141C",
          "#44F802",
          "#C5FF14",
          "#3701E6",
          "#E6DA57",
          "#609FFE",
          "#D803FC",
          // "#FC7C03",
        ];
      });
    },

    // select 筛选方法
    countryFilter(query = "") {
      let arr = this.dev_country.filter((item) => {
        return item.includes(query);
      });
      if (arr.length > 50) {
        this.countryOptions = arr.slice(0, 50);
      } else {
        this.countryOptions = arr;
      }
    },

    cityFilter(query = "") {
      let arr = this.server_city.filter((item) => {
        return item.includes(query);
      });
      if (arr.length > 50) {
        this.cityOptions = arr.slice(0, 50);
      } else {
        this.cityOptions = arr;
      }
    },

    ispFilter(query = "") {
      let arr = this.dev_isp.filter((item) => {
        return item.includes(query);
      });
      if (arr.length > 50) {
        this.ispOptions = arr.slice(0, 50);
      } else {
        this.ispOptions = arr;
      }
    },

    scityFilter(query = "") {
      let arr = this.server_city.filter((item) => {
        return item.includes(query);
      });
      if (arr.length > 50) {
        this.serCityOptions = arr.slice(0, 50);
      } else {
        this.serCityOptions = arr;
      }
    },

    appVerFilter(query = "") {
      let arr = this.pkg_ver.filter((item) => {
        return item.includes(query);
      });
      if (arr.length > 50) {
        this.appVerOptions = arr.slice(0, 50);
      } else {
        this.appVerOptions = arr;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  margin: 20px;
  background: #ffffff;
  position: relative;
  .arrow {
    position: absolute;
    top: 40px;
    right: 0;
    width: 20px;
    height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .content {
    border-radius: 4px;
    width: 100%;
    max-height: 400px;
    margin: 0 auto;
    overflow: hidden;
    transition: all 0.4s ease;
  }
}
.autoHeight {
  max-height: 0px !important;
}
.chart-wrap {
  margin: 20px;
  padding: 20px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 5%);
}
.c-top {
  h4 {
    // font-weight: 400;
    color: #2c2c2c;
  }
}
.tip {
  font-size: 14px;
  color: #409eff;
  i {
    margin-right: 5px;
  }
  span {
    margin-right: 10px;
  }
}
</style>
